import React from 'react';

import { Tag } from 'antd';

import { EPaymentMethod, ShoppingPaymentStatusId } from 'v2/interfaces/shopping';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import { updateDeliveryStatus } from './updateDeliveryStatus';

type PaymentStatusTagProps = {
  delivery: ShoppingDelivery;
};

function getInvoiceTagStyles(paymentStatusId: ShoppingPaymentStatusId) {
  let [color, border, backgroundColor] = ['#1e1e1e', '#d9d9d9 thin solid', '#fafafa'];

  if (
    paymentStatusId === ShoppingPaymentStatusId.ABERTA ||
    paymentStatusId === ShoppingPaymentStatusId.AGUARDANDO_PAGAMENTO
  ) {
    color = '#0958d9';
    border = '#e6f4ff thin solid';
    backgroundColor = '#91caff';
  }

  if (paymentStatusId === ShoppingPaymentStatusId.PAGA || paymentStatusId === ShoppingPaymentStatusId.NEGOCIADA) {
    color = '#389e0d';
    border = '#b7eb8f thin solid';
    backgroundColor = '#f6ffed';
  }

  if (
    paymentStatusId === ShoppingPaymentStatusId.AGUARDANDO_REEMBOLSO ||
    paymentStatusId === ShoppingPaymentStatusId.REEMBOLSADO
  ) {
    color = '#cf1322';
    border = '#ffa39e thin solid';
    backgroundColor = '#fff1f0';
  }

  if (paymentStatusId === ShoppingPaymentStatusId.EM_RECUPERACAO) {
    color = '#d4b106';
    border = '#d4b106 thin solid';
    backgroundColor = '#fffb8f';
  }

  return { color, border, backgroundColor };
}

function PaymentStatusTag({ delivery }: PaymentStatusTagProps) {
  let status = delivery.payment_status;

  if (delivery.payment_method.id === EPaymentMethod.BOLETO_PARCELADO) {
    status = updateDeliveryStatus(delivery);
  }

  const styles = getInvoiceTagStyles(status.id);
  return (
    <Tag key={`status-tag-${delivery.invoice_id}`} style={styles}>
      {status.name}
    </Tag>
  );
}

export default PaymentStatusTag;
